import { useLocation } from "react-router-dom";
import { KioskLandingPage } from "./kiosk-landing-page";
import { KioskResultsPage } from "./kiosk-results-page";

export default function KioskLanding() {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const complete = searchParams.get("complete");
  const sessionId = searchParams.get("sessionId");
  const questionnaireSessionId = localStorage.getItem(
    "ciq-questionnaire.sessionId"
  );

  if (complete && sessionId && !questionnaireSessionId) {
    localStorage.setItem("ciq-questionnaire.sessionId", sessionId);
  }

  return complete ? <KioskResultsPage /> : <KioskLandingPage />;
}
